import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { SpecraButton } from '@mono/ui-components/ensigns';
import { Testids } from '@mono/ui-selectors';
import { useState } from 'react';
import { DocumentPickerDialog } from './DocumentPickerDialog';
import { useRecordDocumentMutations } from './hooks';
export function RecordDocumentLinkButton({ entity, canLink }) {
    const [open, setOpen] = useState(false);
    if (!canLink) return null;
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(SpecraButton, {
                variant: "ghost",
                size: "xs",
                "data-testid": Testids.registryDocuments.linkButton,
                onClick: ()=>setOpen(true),
                children: "Link document"
            }),
            open && /*#__PURE__*/ _jsx(LinkDialog, {
                entity: entity,
                onOpenChange: setOpen
            })
        ]
    });
}
// Mounted only while open, so the button itself needs no query client and each session starts fresh.
function LinkDialog({ entity, onOpenChange }) {
    const { link } = useRecordDocumentMutations();
    return /*#__PURE__*/ _jsx(DocumentPickerDialog, {
        open: true,
        onOpenChange: onOpenChange,
        title: "Link a document",
        confirmLabel: "Link",
        onConfirm: async (d)=>{
            await link.mutateAsync({
                entity,
                artifactId: d.artifactId
            });
        }
    });
}
